/**
 * Anmeldeseite (Design-Handoff Screen 01): Split-Layout mit Markenseite
 * links und Anmelde-Karte rechts. Der Login-Redirect startet automatisch
 * (AuthProvider); diese Seite ist der sichtbare Zwischenstand dabei.
 */

import { Lock } from "lucide-react"

interface Props {
  onLogin: () => void
  /** true, solange der Auto-Redirect bzw. die Sitzungsprüfung läuft */
  laeuft?: boolean
}

export function LoginScreen({ onLogin, laeuft = false }: Props) {
  return (
    <div className="flex min-h-screen bg-slate-900">
      {/* Markenseite */}
      <div className="relative hidden flex-[1.1] flex-col justify-center overflow-hidden p-20 text-white lg:flex">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(circle at 15% 20%, rgba(77,163,255,0.16), transparent 45%), radial-gradient(circle at 85% 85%, rgba(77,163,255,0.10), transparent 40%)",
          }}
        />
        <div className="relative">
          <span className="text-2xl font-bold tracking-tight">
            Fabrik-OS-<span style={{ color: "#4da3ff" }}>Tester</span>
          </span>
          <p className="mt-7 max-w-md text-[2rem] font-semibold leading-snug text-slate-100">
            Fehler und Änderungswünsche direkt im Kontext Ihrer Anwendung erfassen.
          </p>
          <p className="mt-5 max-w-md text-[15px] leading-relaxed text-slate-400">
            Screenshot, Markierung und ein kurzer KI-Dialog genügen — daraus wird eine
            strukturierte Anforderung für netz-fabrik.
          </p>
        </div>
      </div>

      {/* Anmelde-Karte */}
      <div className="flex flex-1 items-center justify-center bg-background">
        <div className="flex w-[380px] max-w-[90vw] flex-col gap-6">
          <div>
            <h1 className="mb-1.5 text-[22px] font-bold">Willkommen zurück</h1>
            <p className="text-sm text-muted-foreground">
              Melden Sie sich mit Ihrem Firmenkonto an, um Ihre Anwendungen zu testen.
            </p>
          </div>
          <button
            type="button"
            onClick={onLogin}
            disabled={laeuft}
            className="flex items-center justify-center gap-2.5 rounded-[10px] bg-primary px-4 py-3 text-[15px] font-semibold text-primary-foreground hover:bg-primary-hover disabled:opacity-60"
          >
            <Lock className="h-[18px] w-[18px]" />
            {laeuft ? "Anmeldung läuft …" : "Mit Firmenkonto anmelden"}
          </button>
          <p className="text-center text-xs text-muted-foreground/80">
            Single Sign-On über Logto · dasselbe Konto wie in Ihrer Anwendung
          </p>
        </div>
      </div>
    </div>
  )
}
